export default __webpack_public_path__ + "static/media/report_doctor.55e53ced.png";